import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";

const getPartnerFrontendBootAPI = ({
  partner,
  signal,
}: {
  partner: string;
  signal?: AbortSignal;
}) =>
  handleGlobalGetRequestQuery({
    url: `/partner/${partner}${URLS.FRONTEND_BOOT}`,
    signal,
  });

export { getPartnerFrontendBootAPI };
